import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

const BOMDetails = () => {
    const privileges = secureLocalStorage.getItem("privileges");
    const location = useLocation();
    const navigate = useNavigate();

    const { useFetch: BOMFetch } = useAPIQuery({
        key: "bom",
        endpoint: `/api/bom/`,
    });

    const { data: Bomdata, isLoading: isBomLoading } = BOMFetch({
        params: {
            action: "fetch_bom",
            product_id: location.state?.item?.product?.id,
        },
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const columns = [
        {
            accessor: "item__item_name",
            header: "Item",
        },
        {
            accessor: "item__item_code",
            header: "Item Code",
        },
        {
            accessor: "department",
            header: "Department",
        },
        {
            accessor: "req_quan_of_item",
            header: "Required Quantity of Item",
        },
        {
            accessor: "item_per_product",
            header: "Item Per Product",
        },
        {
            accessor: "supplier",
            header: "Supplier",
            cell: (row) => (
                <>
                    {row?.supplier__user__first_name +
                        " " +
                        row?.supplier__user__last_name}
                </>
            ),
        },
    ];

    const handleEditRow = (row) => {
        console.log(row);
        navigate("/edit-bom", {
            state: {
                editpost: {
                    product: { id: location.state?.item?.product?.id },
                },
            },
        });
    };

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content">
                        <h4 className="nk-block-title"> BOM Details </h4>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-4 col-sm-12 m-2">
                    <strong>Product name</strong>: {Bomdata?.data?.product_name}
                </div>
                <div className="col-lg-4 col-sm-12 m-2">
                    <strong>Variant</strong>: {Bomdata?.data?.variant}
                </div>
                <div className="col-lg-2 col-sm-12 m-2">
                    <strong>No of shades</strong>: {Bomdata?.data?.no_shades}
                </div>
            </div>
            <Table
                data={Bomdata ? Bomdata?.data?.bom_details : []}
                columns={columns}
                globalSearch
                pagination={false}
                manualFilter={false}
                isLoading={isBomLoading}
                editRows={privileges.includes("bom_update") ? true : false}
                deleteRows={false}
                filterModal={false}
                selectRows={false}
                onRowEdit={handleEditRow}
            />
        </>
    );
};

export default BOMDetails;
